import React, { Component } from 'react';
import { JointSvg } from '../svg/JointSvg';
import { SingleSvg } from '../svg/SingleSvg';

interface IProps {
    gtmEvent(): void;
    nextStep(s: string): void;
    justMe?: "" | "joint" | "single";
}

interface IState {
}


export class InsuranceQuoteFor extends Component<IProps, IState> {

    componentDidMount(): void {
        this.props.gtmEvent();
    }

    render() {

        return (
            <header className="App-header">
                <h1 className='l'>I'd like a <span className='doddltext'>quote</span> for...</h1>
                <div className='wrapper'>
                    <div className='row'>
                        <div className='column2 justify-e'>
                            <div className='boxty big' onClick={() => this.props.nextStep('single')}>
                                <div>
                                    <div><SingleSvg /></div>
                                    <div><span className='b'>Myself</span></div>
                                </div>
                            </div>
                        </div>
                        <div className='column2 justify-s'>
                            <div className='boxty big' onClick={() => this.props.nextStep('joint')}>
                                <div>
                                    <div><JointSvg /></div>
                                    <div><span className='b'>Myself & my partner</span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        );
    }
}
